module.exports = __webpack_public_path__ + "root-c2082cbd/XING-Sans-Bold-a8a92bd52acc953c9ac5d643b2ea0bd3.woff2";